export default __webpack_public_path__ + "static/media/16.ff647c86.jpg";